import React from 'react';
import ResponsiveWrapper from '../../../components/ResponsiveWrapper';
import StandardInfo from './index';
import MobileStandardInfo from './MobileStandardInfo';

const ResponsiveStandardInfo = () => {
  return (
    <ResponsiveWrapper
      mobile={<MobileStandardInfo />}
      desktop={<StandardInfo />}
    />
  );
};

export default ResponsiveStandardInfo;